import { showSuccess, showError } from "utils/notifications";
import { showConfirmBox } from "utils/ConfirmHelper";

const DeleteBtn = ({
  id,
  fetchData,
  apiDeleteFunction,
  itemName = "item",
}) => {

  const deleteHandler = async () => {
    try {
      const confirmed = await showConfirmBox(
        `Are you sure you want to delete this ${itemName}?`
      );
      if (!confirmed) return;

      const response = await apiDeleteFunction({ id });

      if (response?.data?.success) {
        showSuccess(
          response.data?.message || `${itemName} deleted successfully`
        );
        fetchData && fetchData();
      } else {
        showError(
          response?.data?.error || `Failed to delete ${itemName}`
        );
      }
    } catch (error) {
      console.error("Delete error:", error);
      showError(
        error?.response?.data?.message || "Something went wrong"
      );
    }
  };

  return (
    <button
      type="button"
      className="btn btn-danger btn-sm border rounded-2"
      onClick={deleteHandler}
      title={`Delete ${itemName}`}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" />
        <path d="M4 7h16" />
        <path d="M10 11v6" />
        <path d="M14 11v6" />
        <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
        <path d="M9 7V4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
      </svg>
    </button>
  );
};

export default DeleteBtn;
